/* eslint-disable */
import Vue from 'vue'

export const getDownLoadTemplate = params => {
  return Vue.fetch.post('/apiv1/hr/employee/getTempalteUrl', params)
}

/**
 * 组织id 找设备未绑定的人员列表
 * @param {} params
 */
export const getUnbindDeviceEmployeList = params => {
  return Vue.fetch.post(
    '/apiv1/hr/employee/findByOrganizationIdDuplicateRemoval',
    params
  )
}

/**
 * 更新员工
 * @param {} params
 */
export const updateEmployee = params => {
  return Vue.fetch.post('/apiv1/hr/employee/update', params)
}

/**
 * 添加员工
 * @param {} params
 */
export const removeEmployee = params => {
  return Vue.fetch.post('/apiv1/hr/employee/delete', params)
}
/**
 * 添加员工
 * @param {} params
 */
export const addEmployee = params => {
  return Vue.fetch.post('/apiv1/hr/employee/add', params)
}
/**
 * 获取组织架构类型
 * @param {} params
 */
export const getDeptEmployeeList = params => {
  return Vue.fetch.post('/apiv1/hr/employee/findByOrganizationId', params)
}

export const saveEmployeeEnrollment = params => {
  return Vue.fetch.post('/apiv1/hr/employeeEnrollment/save', params)
}

export const deleteBioTemplate = params => {
  return Vue.fetch.post('/apiv1/hr/bioTemplate/delete', params)
}

export const findEmployeeEnrollment = params => {
  return Vue.fetch.post('/apiv1/hr/employeeEnrollment/find', params)
}

export const getVerifyintModel = that => {
  return new Promise((resolve, reject) => {
    let list = [
      { value: 0, label: that.$t('verifyintModel.0') },
      { value: 1, label: that.$t('verifyintModel.1') },
      { value: 2, label: that.$t('verifyintModel.2') },
      { value: 3, label: that.$t('verifyintModel.3') },
      { value: 4, label: that.$t('verifyintModel.4') },
      { value: 5, label: that.$t('verifyintModel.5') },
      { value: 6, label: that.$t('verifyintModel.6') },
      { value: 7, label: that.$t('verifyintModel.7') },
      { value: 8, label: that.$t('verifyintModel.8') },
      { value: 9, label: that.$t('verifyintModel.9') },
      { value: 10, label: that.$t('verifyintModel.10') },
      { value: 11, label: that.$t('verifyintModel.11') },
      { value: 12, label: that.$t('verifyintModel.12') },
      { value: 13, label: that.$t('verifyintModel.13') },
      { value: 14, label: that.$t('verifyintModel.14') },
      { value: 15, label: that.$t('verifyintModel.15') },
      { value: 16, label: that.$t('verifyintModel.16') },
      { value: 17, label: that.$t('verifyintModel.17') },
      { value: 18, label: that.$t('verifyintModel.18') },
      { value: 19, label: that.$t('verifyintModel.19') },
      { value: 20, label: that.$t('verifyintModel.20') },
      { value: 21, label: that.$t('verifyintModel.21') },
      { value: 22, label: that.$t('verifyintModel.22') },
      { value: 23, label: that.$t('verifyintModel.23') },
      { value: 24, label: that.$t('verifyintModel.24') },
      { value: 25, label: that.$t('verifyintModel.25') },
      { value: 26, label: that.$t('verifyintModel.26') },
      { value: 27, label: that.$t('verifyintModel.27') },
      { value: 28, label: that.$t('verifyintModel.28') },
      { value: 29, label: that.$t('verifyintModel.29') },
      { value: 200, label: that.$t('verifyintModel.200') }
    ]
    resolve(list)
  })
}

export const getDevicePermission = that => {
  return new Promise((resolve, reject) => {
    let list = [
      {
        value: 0,
        label: that.$t('devicePermission.0')
      },
      {
        value: 14,
        label: that.$t('devicePermission.14')
      }
    ]
    resolve(list)
  })
}


// WEBPACK FOOTER //
// ./src/services/employeeApi.js